export default {"src":"/_next/static/image/public/images/social_twitter_blue.ca847cbef263db4d8a210764cf31a0e7.svg","height":13,"width":16};